<template>
    <span class="transfer-icon-wrapper" @mousedown="iconPress">
        <Icon class="transfer-icon" :width="18" :height="13"/>
    </span>
</template>

<script>
import Icon from './Icon'

export default {
    name: "TransferIcon",
    components: {
        Icon,
    },
    methods: {
        iconPress(event) {
            this.$emit("transfer", event);
        }
    }
};
</script>

<style lang="scss" scoped>
.transfer-icon-wrapper {
    cursor: pointer;
    display: inline-flex;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 2px 6px rgba(46, 98, 151, 0.2);
    background: #fff;

    .transfer-icon {
        background-position: -321px -18px;
        vertical-align: middle;
    }

    &:hover {
        .transfer-icon {
            background-position: -321px -34px;
        }
    }
}
</style>